export const clearHubDataFromStorage = () => {
    localStorage.removeItem('hub_code');
    localStorage.removeItem('hub_name');
};


// WEBPACK FOOTER //
// ./src/services/hubs.js